
<template>
    <div>
        <v-row>
            <v-col cols="12" md="7" class="ma-0 pa-0" :class="{
                                            'hideme': $vuetify.breakpoint.smAndDown
                                        }">
                <div class="sign-three relative">
                    <!--<div class="sign-three-overlay"></div>-->
                    <div class="sign-three-content z-10">
                        <div class="section-left-content">
                            <!--<h1 class="text-4xl font-weight-bold white--text">
                                Ready To Create?
                            </h1>
                            <p class="font-weight-medium body-2">
                                From one ad banner to an entire new store.
                            </p>-->
                            <!--<v-btn large color="orange white--text"
                                >Sign Up</v-btn
                            >-->
                        </div>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" md="5" class="ma-0 pa-0">
                <div class=" ma-0 pa-0 " :class="{
                                            'sign-three': $vuetify.breakpoint.smAndDown
                                        }">
                    <div
                        class="d-flex justify-center align-center text-center  md:h-screen h-full"
                    >
                        <div style="margin-top: 30%; width: 400px;">



                            <base-card style="background: transparent">
                <v-progress-linear
                    :active="loading"
                    :indeterminate="loading"
                    absolute
                    top
                    color="primary"
                ></v-progress-linear>
                <v-card-text class="text-center">
                    <!-- <v-avatar size="60">
                        <img src="@/assets/images/logo.svg" alt="" />
                    </v-avatar> -->
                    <img src="@/assets/images/adpoints-logo-w.png" alt="" style="margin: 20px auto; max-width: 70%;" />                    
                    <h6 class="text--disabled font-weight-medium mb-10">
                        Sign in to your account
                    </h6>
                    <v-form>
                        <v-text-field
                            label="email"
                            v-model="email"
                            :rules="emailRules"
                            required
                            :validate-on-blur="true"
                        />
                        <!-- <v-text-field
                            label="email"
                            v-model="email"
                            :rules="emailRules"
                            required                            
                        /> -->

                        <v-text-field
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            name="input-10-2"
                            label="password"                            
                            :rules="nameRules"
                            v-model="ePassword"
                            @click:append="show = !show"
                            :validate-on-blur="true"
                        ></v-text-field>
                        <!-- <v-text-field
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            name="input-10-2"
                            label="password"
                            :counter="10"
                            :rules="nameRules"
                            v-model="ePassword"
                            @click:append="show = !show"                            
                        ></v-text-field> -->

                        <!-- <v-checkbox
                            v-model="checkbox1"
                            label="Remember this computer"
                        ></v-checkbox> -->
                        <v-btn
                            class="mb-4"
                            @click="formSubmit"
                            block
                            color="primary"
                            dark
                        >
                            <v-icon left>mdi-login</v-icon>
                            Sign In</v-btn
                        >
                        <v-alert dense outlined type="error" v-if="error">
                            {{ error }}
                        </v-alert>
                        <div class="d-flex justify-around flex-wrap">                            
                            <!--<v-btn
                                text
                                small
                                color="primary"
                                to="/auth/signup"
                                >Create New Account</v-btn
                            >
                            <v-btn text small color="primary" class="mb-2"
                            to="/auth/forgotpass"
                                >Forgot Password</v-btn
                            >-->
                        </div>
                    </v-form>
                </v-card-text>
            </base-card>
                       
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import {api} from "src/api/index";
export default {
    name: 'login',
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'SignIn'
    },
    data() {
        return {
            show: false,
            password: '',
            checkbox1: true,
            checkbox2: false,
            email: '',
            ePassword: '',            
            loading: false,
            emailRules: [
                (v) => !!v || 'E-mail is required',
                (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
            ],
            nameRules: [
                (v) => !!v || 'Password is required',
               
            ]
        }
    },
    computed: {
        ...mapGetters(['loggedInUser', 'error'])
    },
    methods: {
        ...mapActions(['login']),
        formSubmit() {     
            //this.error = '';       
            this.login({username: this.email, password: this.ePassword})            
        },        
    },
    watch: {
        // loading (val) {
        //   if (!val) return
        //   setTimeout(() => (this.loading = false), 2000)
        // },
        loggedInUser(val) {
            if (val && val.token && val.token.length > 0) {
                // this.makeToast("success", "Successfully Logged In");
                console.log('logged in successfully ')
                this.loading = true
                setTimeout(() => { 
                    this.$router.push('/')
                }, 500)
            }
        },
        error(val) {            
            if (val != null) {
                this.error = val.message;                
            }
        }
    }
}
</script>
<style lang="scss" scoped>

.hideme {
    display: none !important;
}

.sign-three {
    background-size: cover !important;
    color: #fff;
    width: 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding: 2rem;
    background: url('../../assets/images/signin-left.jpg');
    .sign-three-overlay {
        content: '';
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        background: rgba(0, 0, 0, 0.65);
        z-index: 1;
    }
}

.page-wrap {
    //background-color: #242939 !important;
    background-color: #f2f4f4 !important;
    display: flex;
    align-items: center;
    padding: 40px 1rem;
    height: 100%;
    min-height: 100vh;
}
.session-form-hold {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}
</style>
